import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./components/header";
import EntryForm from "./components/entry-form";
import Results from "./components/results";
import { add, formatISO, sub } from "date-fns";
import "./retro.css";

const AppContainer = styled.div`
  height: 100%;
  min-height: 100vw;
  padding: 8px;
`;

const fib = (n, idx = 0, a = 0, b = 1, fibs = []) =>
  idx === n || isNaN(a + b)
    ? [...fibs]
    : fib(n, idx + 1, b, a + b, [...fibs, a + b]);

const generateResults = ({ date, interval, operator, cycles }) => {
  let result = Number(cycles) && fib(Number(cycles));
  return result.map(n => {
    try {
      return operator === "add"
        ? {
            n,
            fibDate: formatISO(add(date, { [interval]: n }), {
              representation: "date",
            }),
          }
        : {
            n,
            fibDate: formatISO(sub(date, { [interval]: n }), {
              representation: "date",
            }),
          };
    } catch {
      return { n, fibDate: "Out of Bounds." };
    }
  });
};

const App = () => {
  const [results, setResults] = useState([]);
  const [formVals, setFormVals] = useState({
    date: new Date(),
    interval: "days",
    operator: "add",
    cycles: "10",
  });
  const handleChange = ({ target }) => {
    return setFormVals({ ...formVals, [target.name]: target.value });
  };
  useEffect(() => {
    if (formVals.cycles > 0) {
      let result = generateResults(formVals);

      setResults(result);
    }
  }, [formVals]);

  return (
    <AppContainer>
      <Header />
      <EntryForm handleChange={handleChange} formVals={formVals} />
      {results.length && <Results results={results} />}
    </AppContainer>
  );
};

export default App;
